module.exports = __webpack_public_path__ + "img/0S6A9886.282942b3.jpg";